
import * as EnumDatepicker from '@tunnel-enums/styled/index';
import styled, {css} from 'styled-components';

{ /** Utilisation des props modifier */
}

/**
 * @description : modification des props
 * @const
 * @name  CartContainer
 */
export const CartContainer = styled.div` 
    position: relative;
    
    align-items: center;
    justify-content: flex-start;
    width:100%;
    heigth:auto;
    background-color: ${EnumDatepicker.CSS.WHITE};
  `;
/**
 * @description : modification des props
 * @const
 * @name  Container
 */
export const Container = styled.div<ContainerProps>`
    width: 100%;
    padding: 0;
    min-width:100px;
    right:1px;
    heigth:auto;
    -moz-box-shadow: 5px 2px 30px 0px rgba(230,230,230,.45);
    -ms-box-shadow: 5px 2px 30px 0px rgba(230,230,230,.45);
    -webkit-box-shadow: 5px 2px 30px 0px rgba(230,230,230,.45);
    box-shadow: 5px 2px 30px 0px rgba(230,230,230,.45);
    border-radius: ${EnumDatepicker.CSS.BORDER_RADIUS};
    overflow: hidden;
    background: ${EnumDatepicker.CSS.WHITE};
    position: absolute;
    z-index: 10000;
    top: 40px;
    transform: translateY(20px);
    opacity: 0;
    visibility: hidden;
    transform-origin: top center;
    transition: transform 0.3s ease, opacity 0.2s ease, visibility 0s ease 0.3s;
    display: flex;
    flex-direction: column;

    ${(props: ContainerProps) => props.isVisible && css`
            transform: translateY(0);
            opacity: 1;
            visibility: visible;
            transition: transform 0.3s ease, opacity 0.2s ease,
                visibility 0s ease;
        `}
  `;
// ====================================================================================================
{ /** INTERFACES */
}
// ====================================================================================================

/**
 * @interface ContainerProps
 * @description :
 * Cette interface définit le model du props
 */
interface ContainerProps {
  isVisible?: boolean;
}



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/@styled/cart/index.ts